<script>
export default {
  name: 'SettingModel',
  props: {
    releaseStatus: {
      type: String,
      default: 'draft',
    },
    releaseStatusOperation: {
      type: Object,
      default: () => ({
        draft: () => {},
        release: () => {},
        end: () => {},
      }),
    },
    startAt: {
      type: Number,
      default: 0,
    },
    endAt: {
      type: Number,
      default: 0,
    },
    deleteOperation: {
      type: Function,
      default: () => {},
    },
    saveOperation: {
      type: Function,
      default: () => {},
    },
    saveOperationBtnColor: {
      type: String,
      default: 'primary',
    },
    previewOperation: {
      type: Function,
      default: () => {},
    },
    contentBlockRWD: {
      type: Object,
      default: () => ({
        form: 5,
        demo: 7,
      }),
    },
    stepper: {
      type: Array,
      default: () => ['基本設定'],
    },
    stepperShowPage: {
      type: Number,
      default: 1,
    },
    hiddenDeleteBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stepper_show_page: this.stepperShowPage,
    }
  },
  computed: {
    // release_status block
    release_status_color() {
      const types = {
        draft: this.$vuetify.theme.themes.light.draft,
        release: this.$vuetify.theme.themes.light.release,
        end: this.$vuetify.theme.themes.light.end,
      }
      return types[this.releaseStatus]
    },
    release_status_title() {
      const types = {
        draft: { text: '未發布(不會顯示)', icon: 'mdi-timer-outline' },
        release: { text: '發布中(顯示)', icon: 'mdi-timer-outline' },
        end: { text: '已結束', icon: 'mdi-check-circle-outline' },
      }
      return types[this.releaseStatus]
    },
    release_status_operation_btn() {
      const types = {
        draft: {
          text: '發布',
          icon: 'mdi-play-circle-outline',
          color: '#f5f5f5',
          text_color: this.$vuetify.theme.themes.light.draft,
        },
        release: {
          text: '停止發布',
          icon: 'mdi-stop-circle-outline',
          color: '#f5f5f5',
          text_color: this.$vuetify.theme.themes.light.release,
        },
        end: {
          text: '返回草稿',
          icon: 'mdi-chevron-left',
          color: '#f5f5f5',
          text_color: this.$vuetify.theme.themes.light.end,
        },
      }
      return types[this.releaseStatus]
    },
    release_status_time() {
      const types = {
        draft: { text_color: 'white--text', bg_color: 'orange darken-2' },
        release: { text_color: 'white--text', bg_color: 'green darken-2' },
        end: { text_color: 'white--text', bg_color: 'grey darken-2' },
      }
      return types[this.releaseStatus]
    },
  },
  watch: {
    stepper_show_page: {
      handler(new_val) {
        this.$emit('update-stepper_show_page', new_val)
      },
    },
    stepperShowPage: {
      handler(new_val) {
        this.stepper_show_page = new_val
      },
    },
  },
}
</script>

<template>
  <div class="pa-3">
    <!-- release status block -->
    <v-card>
      <v-sheet class="d-flex justify-space-between align-center py-2 px-3" :color="release_status_color">
        <div class="d-flex">
          <v-icon color="white" v-text="release_status_title.icon" />
          <v-card-title class="white--text pa-3">{{ release_status_title.text }}</v-card-title>
        </div>
        <v-btn :color="release_status_operation_btn.color" @click="releaseStatusOperation[releaseStatus]()">
          <v-icon left :color="release_status_operation_btn.text_color" v-text="release_status_operation_btn.icon" />
          <span :style="`color: ${release_status_operation_btn.text_color}`">
            {{ release_status_operation_btn.text }}
          </span>
        </v-btn>
      </v-sheet>
      <v-row
        v-if="startAt"
        no-gutters
        :class="`d-flex justify-space-between pa-2 ${release_status_time.bg_color} ${release_status_time.text_color}`"
      >
        <v-col cols="12" lg="6" class="px-2 text-subtitle-1">{{ `開始： ${$utils.displayISOString(startAt)}` }}</v-col>
        <v-col cols="12" lg="6" class="px-2 text-subtitle-1">{{ `結束： ${$utils.displayISOString(endAt)}` }}</v-col>
      </v-row>
    </v-card>

    <v-row class="mt-3">
      <v-col cols="12" :md="contentBlockRWD.form">
        <!-- btn group -->
        <v-card class="d-flex justify-space-between align-center pa-3">
          <v-btn color="primary" @click="$router.go(-1)" v-text="'回上一頁'" />
          <div class="d-flex" style="gap: 12px">
            <v-btn v-if="!hiddenDeleteBtn" color="error" @click="deleteOperation()" v-text="'刪除'" />
            <v-btn :color="saveOperationBtnColor" @click="saveOperation()" v-text="'保存'" />
            <v-btn color="primary" @click="previewOperation()" v-text="'預覽'" />
          </div>
        </v-card>

        <!-- stepper block -->
        <v-stepper v-model="stepper_show_page">
          <v-stepper-header>
            <template v-for="(step_title, index) in stepper">
              <v-stepper-step :key="`step_tab_${index}`" editable :step="index + 1">{{ step_title }}</v-stepper-step>
              <v-divider v-if="index < stepper.length - 1" :key="`step_tab_line${index}`" />
            </template>
          </v-stepper-header>
          <v-stepper-items>
            <template v-for="(step_title, index) in stepper">
              <v-stepper-content :key="`step_item_${index}`" :step="index + 1">
                <div class="step-content-title px-4">
                  <h2 class="primary--text" v-text="step_title" />
                </div>

                <slot :name="step_title" />
              </v-stepper-content>
            </template>
          </v-stepper-items>
        </v-stepper>
      </v-col>

      <!-- demo block -->
      <v-col cols="12" :md="contentBlockRWD.demo">
        <slot name="demo" />
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.step-content-title {
  border-left: 5px solid var(--v-primary-base);
  background: rgb(215, 227, 248);
}
</style>
